// @flow

import React from 'react';
import styled from 'styled-components';

import type { Goal } from '../types/Goal';
import SYProgressBar from './SYProgressBar';
import { SPACING_BASE, WHITE_COLOR } from '../config/constants';
import CardHead from './CardHead';
import SYTag11ptExtended from './SYTag11ptExtended';
import SYHeadlineFive from './SYHeadlineFive';
import { themeSkillYoga } from '../styles/themeSkillYoga';

const GoalCardHeadContainer = styled(CardHead)`
  margin: 0;
  padding: 0;

  ${(props) => !props.divider && (
    `border-bottom: 0;
    box-shadow: none;`
  )}
`;

const GoalCardPropsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: ${themeSkillYoga.getGutterSpacing()} 0 0;
`;

const GoalCardProp = styled.div``;

class GoalCardHead extends React.PureComponent<{
  goal: Goal,
  style?: Object,
  divider?: boolean,
  className?: string,
}> {
  static defaultProps = {
    style: null,
    divider: false,
    className: undefined,
  };

  render(): React$Element<*> {
    const {
      divider,
      goal,
      style,
      className,
    } = this.props;

    return (
      <GoalCardHeadContainer style={style} divider={divider} className={className}>
        <SYHeadlineFive>{goal.label}</SYHeadlineFive>

        <GoalCardPropsWrapper key={`goal-selector-${goal.id}`}>
          <GoalCardProp>
            <SYProgressBar percentage={goal.strengthPercentage} fillColor={WHITE_COLOR} style={{ marginBottom: SPACING_BASE }} />
            <SYTag11ptExtended>STRENGTH</SYTag11ptExtended>
          </GoalCardProp>

          <GoalCardProp>
            <SYProgressBar percentage={goal.mobilityPercentage} fillColor={WHITE_COLOR} style={{ marginBottom: SPACING_BASE }} />
            <SYTag11ptExtended>MOBILITY</SYTag11ptExtended>
          </GoalCardProp>

          <GoalCardProp>
            <SYProgressBar percentage={goal.mindfulnessPercentage} fillColor={WHITE_COLOR} style={{ marginBottom: SPACING_BASE }} />
            <SYTag11ptExtended>MINDFULNESS</SYTag11ptExtended>
          </GoalCardProp>
        </GoalCardPropsWrapper>
      </GoalCardHeadContainer>
    );
  }
}

export default GoalCardHead;
